import { render, staticRenderFns } from "./GradingButton.vue?vue&type=template&id=0852a6e4&scoped=true"
import script from "./GradingButton.vue?vue&type=script&lang=js"
export * from "./GradingButton.vue?vue&type=script&lang=js"
import style0 from "./GradingButton.vue?vue&type=style&index=0&id=0852a6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852a6e4",
  null
  
)

export default component.exports